import { DOCUMENT } from '@angular/common';
import { Directive, ElementRef, Output, EventEmitter, HostListener, inject } from '@angular/core';


import { DropdownComponent } from '../../dropdown/dropdown.component';

@Directive({
    selector: '[appClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
    private readonly elementRef = inject(ElementRef);
    private readonly document = inject<Document>(DOCUMENT);

    @Output('appClickOutside')
    public clickOutside = new EventEmitter<Event>();

    @HostListener('document:click', ['$event'])
    public onClick(event: Event) {
        const modalContent = this.document.querySelector('.modal-content');
        if (modalContent) {
            const insideModal = modalContent.contains(this.elementRef.nativeElement);
            if (!insideModal) {
                return;
            }
        }

        const selectOpened = this.document.querySelector(`.${DropdownComponent.CustomSelectOpenedClass}`);
        const clickedInside = this.elementRef.nativeElement.contains(event.target);
        if (!clickedInside && !selectOpened) {
            this.clickOutside.emit(event);
        }
    }
}
